import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const StepTransition = ({ children, direction = 'next' }) => {
  const variants = {
    enter: (direction) => ({
      x: direction === 'next' ? 20 : -20,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction) => ({
      x: direction === 'next' ? -20 : 20,
      opacity: 0
    })
  };

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={`step-${direction}-${Date.now()}`}
        custom={direction}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{
          x: { duration: 0.15, ease: "easeOut" },
          opacity: { duration: 0.2, ease: "easeInOut" }
        }}
        className="w-full"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default StepTransition; 
